import { ResidencyTypeState } from './types';

const state = (): ResidencyTypeState => {
  return {
    residencyTypes: [],
  };
};

export default state;
